import { Route, Routes } from 'react-router-dom';
import { HomePage } from './pages/home/HomePage';
import { AccessibilityPage } from './pages/accessibility/AccessibilityPage';
import { NotFoundPage } from './pages/not-found/NotFoundPage';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/accessibility" element={<AccessibilityPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
